import React, { useContext, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { toast } from "react-toastify";

import api from "../../services/api";
import { i18n } from "../../translate/i18n.js";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SettingsContext } from "../../context/Settings/SettingsContext";
import ConfirmationModal from "../ConfirmationModal";
import { fmtDate } from "../../translate/localeHelper";

// feat_416 (CK23) — ficha del contacto: ¿ya recibió el mensaje de bienvenida
// "una sola vez"? Solo admin y solo con el ajuste welcomeNoticeOnce prendido.
// Si el contacto no trae la propiedad (backend anterior) no se muestra nada.
const WelcomeNoticeContactRow = ({ contact }) => {
  const { user } = useContext(AuthContext);
  const { getSetting } = useContext(SettingsContext);
  const [confirmOpen, setConfirmOpen] = useState(false);

  if (!contact || user?.profile !== "admin") return null;
  if (getSetting("welcomeNoticeOnce") !== "true") return null;
  if (!Object.prototype.hasOwnProperty.call(contact, "welcomeNoticeAt")) return null;

  const at = contact.welcomeNoticeAt;

  const handleReset = async () => {
    try {
      await api.delete(`/contacts/${contact.id}/welcome-notice`);
      toast.success(i18n.t("welcomeNotice.resetDone"));
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Paper square variant="outlined" style={{ padding: "8px 16px", marginTop: 8 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <div style={{ minWidth: 0 }}>
          <Typography variant="subtitle2">{i18n.t("welcomeNotice.contactTitle")}</Typography>
          <Typography variant="caption" color="textSecondary">
            {at
              ? i18n.t("welcomeNotice.contactSent", { date: fmtDate(new Date(at)) })
              : i18n.t("welcomeNotice.contactNotSent")}
          </Typography>
        </div>
        {at && (
          <Button size="small" color="primary" onClick={() => setConfirmOpen(true)} style={{ flexShrink: 0 }}>
            {i18n.t("welcomeNotice.resetButton")}
          </Button>
        )}
      </div>
      <ConfirmationModal
        title={i18n.t("welcomeNotice.resetConfirmTitle")}
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleReset}
      >
        {i18n.t("welcomeNotice.resetConfirmBody")}
      </ConfirmationModal>
    </Paper>
  );
};

export default WelcomeNoticeContactRow;
